import { Box, Button, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';

import { Download } from '@mui/icons-material';
import { concat } from 'lodash';
import SummaryLine from '../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import Schema from '../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { GetMaxDecimalValidation, GetMinMaxDecimalValidation } from '../../../../../../lib/validation/ValidationTypes';
import { DisplayDate, DisplayDateTime, DisplayDecimal, DisplayEuro } from '../../../../../../utils/formats';
import { isTrue } from '../../../../../../utils/helper';
import { DownloadAntragPDF } from '../../../DownloadAntragPDF';
import { getErrorMessage, getHasError } from '../../../../../../lib/validation/validationHelperFunction';

const P = Schema.attributes;

const Abschluss: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, saveApplication, errors, tree } = useApplication();

	const BemerkungStruc = [{ fields: [P.Allgemein_Hinweise_An_SDO], userProps: { columnToDivide: 1 } }];

	const handleDownloadAntrag = () => {
		DownloadAntragPDF(application, readOnly, saveApplication);
	};

	return (
		<>
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1rem' }}>
				<Typography variant="h3" component={'h2'}>
					{' '}
					Antragsübersicht
				</Typography>

				<Typography>Überprüfen Sie noch einmal die wichtigsten Daten.</Typography>

				<Box sx={{ width: '100%' }}>
					<SummaryLine
						label="Datum der Einreichung:"
						value={
							get(application, P.Allgemein_Eingereicht_Am.path)
								? DisplayDateTime(get(application, P.Allgemein_Eingereicht_Am.path))
								: 'noch nicht eingereicht'
						}
					/>

					<SummaryLine label="Projekttitel:" value={get(application, P.Allgemein_Projekttitel.path)} />

					<SummaryLine label="Name des Antragstellenden:" value={get(application, P.Antragstellerin_Name.path)} />

					<SummaryLine
						label="Durchführungszeitraum von:"
						value={DisplayDate(get(application, P.Allgemein_Geplanter_Durchfuehrungszeitraum_von.path))}
					/>
					<SummaryLine
						label="Durchführungszeitraum bis:"
						value={DisplayDate(get(application, P.Allgemein_Geplanter_Durchfuehrungszeitraum_bis.path))}
					/>

					<SummaryLine label="Projektstart (Jahr):" value={get(application, P.Allgemein_Projektstart_Jahr.path)} />

					<SummaryLine
						label="Geplante Projektausgaben:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Gesamtausgaben_Geplant.path, ''))}
					/>
					<SummaryLine
						label="Geplante Eigen- und Drittmittel:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Gesamteinnahmen_Geplant.path, ''))}
					/>
					<SummaryLine
						label="Beantragte Zuwendung:"
						value={DisplayEuro(get(application, P.Zusammenfassung_Foerdersumme_Geplant.path, ''))}
						error={getHasError(errors, tree, P.Zusammenfassung_Foerdersumme_Geplant)}
						errorMessage={getErrorMessage(errors, P.Zusammenfassung_Foerdersumme_Geplant.path)}
					/>

					<SummaryLine
						label="Förderquote:"
						value={DisplayDecimal(get(application, P.Zusammenfassung_Foerderquote_Geplant.path, 0), true)}
						error={getHasError(errors, tree, P.Zusammenfassung_Foerderquote_Geplant)}
						errorMessage={getErrorMessage(errors, P.Zusammenfassung_Foerderquote_Geplant.path)}
					/>
				</Box>

				<Typography sx={{ mt: '1rem' }} variant="h6">
					Geförderdete Summe/Förderquote gemäß Programmrichtlinie
				</Typography>
				<Box sx={{ width: '100%' }}>
					<SummaryLine
						label="Minimale Fördersumme gemäß Programm:"
						value={DisplayEuro(
							get(application, P.Foerderprogramm.schema.attributes.Allgemein_Bagatellgrenzeminimale_Foerdersumme.path),
						)}
					/>
					<SummaryLine
						label="Maximale Fördersumme gemäß Programm:"
						value={DisplayEuro(get(application, P.Foerderprogramm.schema.attributes.Allgemein_Maximale_Foerderung.path))}
					/>
					<SummaryLine
						label={'Förderquote'}
						value={DisplayDecimal(
							get(application, P.Foerderprogramm.schema.attributes.Allgemein_Foerderquote_In.path, 0),
							true,
						)}
					/>
				</Box>

				{isTrue(get(application, P.Foerderprogramm.schema.attributes.Allgemein_Unterschriebener_Antrag_Notwendig.path)) && (
					<>
						<Stack spacing={3} sx={{ width: '100%', mt: '1rem' }}>
							<Typography variant="h6">Finale Schritte</Typography>
							<Typography>
								Damit Sie den Antrag einreichen können, möchten wir Sie bitten folgende Schritte durchzuführen:
							</Typography>
							<Typography>1. Laden Sie sich zunächst Ihren ausgefüllten Antrag herunter</Typography>
							<Button variant="outlined" startIcon={<Download />} onClick={() => handleDownloadAntrag()}>
								Antrag herunterladen
							</Button>
							<Typography>
								2. Bitte unterschreiben Sie den Antrag und senden Sie an:
								<br />
								Stadt Dortmund
								<br />
								Südwall 2-4
								<br />
								44122 Dortmund
							</Typography>
							<Typography>3. Laden Sie das unterschriebene Dokument über das Uploadfeld hoch</Typography>
						</Stack>

						<Box sx={{ display: 'flex', width: '100%', alignItems: 'baseline' }}>
							<Box sx={{ width: '50%', paddingLeft: '1rem' }}>
								<CreateForm
									formStruc={formStruc}
									formValues={application}
									updateFormValuesFunc={setApplicationProperty}
									readOnly={readOnly}
								/>
							</Box>
						</Box>
					</>
				)}
			</Box>

			<Box sx={{ mt: '1rem' }}>
				<CreateForm
					formStruc={BemerkungStruc}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</Box>
		</>
	);
};

export default Abschluss;

const formStruc = [{ fields: [{ ...P.Allgemein_Eingereichter_Antrag, hideLabel: true }], userProps: { columnToDivide: 1 } }];

const customFormStruc = (minValue: number, maxValue: number, maxFoerderquote: number): FormStrucItem[] => {
	return [
		{
			fields: [
				{
					...P.Zusammenfassung_Foerdersumme_Geplant,
					validation: [{validateFunction: GetMinMaxDecimalValidation, params: [
						minValue, 
						maxValue,
						`Die beantragte Zuwendung muss zwischen ${DisplayEuro(minValue)} und ${DisplayEuro(maxValue)} liegen`
					]}]
				},
				{
					...P.Zusammenfassung_Foerderquote_Geplant,
					validation: [{validateFunction: GetMaxDecimalValidation, params: [
						maxFoerderquote,
						`Die maximale Förderquote beträgt ${DisplayDecimal(maxFoerderquote,true,)}`
					]}]
				}
			]
		}
	]
}

export const GetAbschlussFormStruc = (application: any) => {
	const minValue = get(application, P.Foerderprogramm.schema.attributes.Allgemein_Bagatellgrenzeminimale_Foerdersumme.path)
	const maxValue = get(application, P.Foerderprogramm.schema.attributes.Allgemein_Maximale_Foerderung.path)
	const maxFoerderquote = get(application, P.Foerderprogramm.schema.attributes.Allgemein_Foerderquote_In.path, 0)
	if(isTrue(get(application, P.Foerderprogramm.schema.attributes.Allgemein_Unterschriebener_Antrag_Notwendig.path))) {
		return concat(formStruc, customFormStruc(minValue, maxValue, maxFoerderquote));
	} else {
		return customFormStruc(minValue, maxValue, maxFoerderquote)
	}
};
